import {
  buildCreateContactFormEmail,
  buildCreateContactFormPhone,
  buildCreateContactFormTwitterField,
  buildCreateContactLinkField,
} from '../../../../../helpers/createContactFormHelpers';
import {CustomFieldAttribute} from '../../../../../models/api/customFieldAttributeModel';
import {AppAction} from '../../../../appActions';
import {actionIsCreateAccountFormAction} from '../../../accounts/createAccountForm/createAccountFormActions';
import {contactsManagerCreateAccountFormReducer} from '../../../accounts/createAccountForm/createAccountFormReducer';
import {actionIsCreateContactFormAction} from '../../../contacts/createContactForm/createContactFormActions';
import {contactsManagerCreateContactFormReducer} from '../../../contacts/createContactForm/createContactFormReducer';
import {actionIsAccountDetailsAction} from './contactsManagerAccountDetailsActions';
import {contactsManagerAccountDetailsReducer} from './contactsManagerAccountDetailsReducer';
import {AccountDetailsState} from './contactsManagerAccountDetailsState';
import {ContactsManagerCreateAccountFormState} from './contactsManagerCreateAccountFormState';
import {ContactsManagerCreateContactFormState} from './contactsManagerCreateContactFormState';
import {contactsManagerMergeContactsReducer} from './contactsManagerMergeContactsReducer';
import {ContactsManagerSidePanelActionsEnum} from './contactsManagerSidePanelActions';
import {
  ContactsManagerSidePanelState,
  sidePanelIsAccountDetails,
  sidePanelIsCreateAccountForm,
  sidePanelIsCreateContactForm,
} from './contactsManagerSidePanelState';
import {ContactsManagerSidePanelTypesEnum} from './contactsManagerSidePanelStateBase';

export function contactsManagerSidePanelReducer(
  state: ContactsManagerSidePanelState | undefined,
  action: AppAction,
): ContactsManagerSidePanelState | undefined {
  if (actionIsCreateContactFormAction(action) && sidePanelIsCreateContactForm(state)) {
    return contactsManagerCreateContactFormReducer(state, action);
  }

  if (actionIsCreateAccountFormAction(action) && sidePanelIsCreateAccountForm(state)) {
    return contactsManagerCreateAccountFormReducer(state, action);
  }

  if (actionIsAccountDetailsAction(action) && sidePanelIsAccountDetails(state)) {
    return contactsManagerAccountDetailsReducer(state, action);
  }

  switch (action.type) {
    case ContactsManagerSidePanelActionsEnum.OPEN_CREATE_CONTACT_FORM: {
      return buildInitialCreateContactFormState(action.payload.access, action.payload.customAttributes);
    }
    case ContactsManagerSidePanelActionsEnum.OPEN_CREATE_ACCOUNT_FORM: {
      return buildInitialCreateAccountFormState(action.payload.customAttributes);
    }
    case ContactsManagerSidePanelActionsEnum.OPEN_ACCOUNT_DETAILS: {
      if (state) {
        return state;
      }
      return buildInitialAccountDetailsState();
    }
    case ContactsManagerSidePanelActionsEnum.CLOSE_SIDE_PANEL: {
      return undefined;
    }

    // Pass to the merge contacts reducer for any merge actions.
    case ContactsManagerSidePanelActionsEnum.OPEN_MERGE_CONTACTS:
    case ContactsManagerSidePanelActionsEnum.PREVIEW_MERGE_CONTACTS:
    case ContactsManagerSidePanelActionsEnum.PREVIEW_MERGE_CONTACTS_COMPLETED:
    case ContactsManagerSidePanelActionsEnum.PREVIEW_MERGE_CONTACTS_FAILED:
      return contactsManagerMergeContactsReducer(state, action);

    default: {
      return state;
    }
  }
}

export function buildInitialCreateContactFormState(
  access: string,
  customAttributes: ReadonlyArray<CustomFieldAttribute>,
): ContactsManagerCreateContactFormState {
  return {
    type: ContactsManagerSidePanelTypesEnum.CREATE_CONTACT,
    name: '',
    description: '',
    avatarFile: undefined,
    access,
    accountId: undefined,
    contactFields: [
      buildCreateContactFormEmail(),
      buildCreateContactFormPhone(),
      buildCreateContactFormTwitterField(),
    ],
    customAttributes,
    createStatus: undefined,
    links: [buildCreateContactLinkField()],
    cardGroupIds: [],
  };
}

export function buildInitialCreateAccountFormState(
  customAttributes: ReadonlyArray<CustomFieldAttribute>,
): ContactsManagerCreateAccountFormState {
  return {
    type: ContactsManagerSidePanelTypesEnum.CREATE_ACCOUNT,
    name: '',
    description: '',
    avatarFile: undefined,
    domains: [],
    customAttributes,
    createStatus: undefined,
  };
}

export function buildInitialAccountDetailsState(): AccountDetailsState {
  return {
    type: ContactsManagerSidePanelTypesEnum.ACCOUNT_DETAILS,
  };
}
